import { Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LockScreenComponent } from './lockscreen/lockscreen.component';
import { VerifierRegisterComponent } from './verifier-register/verifier-register.component';
import { VerifierLoginComponent } from './verifier-login/verifier-login.component';
import { RMLoginComponent } from './rm-login/rm-login.component';
import { PartnerLoginComponent } from './partner-login/partner-login.component';

export const SessionRoutes: Routes = [{
  path: '',
  redirectTo: 'check-account',
  pathMatch: 'full',

}, {
  path: '',
  children: [
    {
      path: 'rm-login',
      component: RMLoginComponent
    },
    {
      path: 'login',
      component: LoginComponent
    }, 
    {
      path: 'register',
      component: RegisterComponent,
    },
    {
      path: 'forgot-password',
      component: ForgotPasswordComponent
    }, 
    {
      path: 'lockscreen',
      component: LockScreenComponent
    },
    {
      path: 'VerifierRegister',
      component: VerifierRegisterComponent
    },
    {
      path: 'VerifierLogin',
      component: VerifierLoginComponent
    },
    {
      path: 'partner-login',
      component: PartnerLoginComponent
    }
  ]
}];
